import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ConfirmDialogService, ScreenSizeDetectorService } from '@serviceplan/ui-kit';
import { AssetUIModel, ClientEnvironment, ENVIRONMENT, SearchAssetsFieldPlaceholder, ViewType, anyAsset } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';
import { Observable } from 'rxjs';
import { AssetCommonService } from '../../../../services/asset-common.service';
import { AssetViewTypeService, GridConfig } from '../../../../services/asset-view-type.service';
import { CollectionInfo } from '../../collection-info.model';
import { CollectionEventsService } from '../../services/collection-events.service';
import { CollectionSelectionService } from '../../services/collection-selection.service';
import { CollectionAssetCommonService } from '../collection-assets-common.service';
import { MenuSettingsData } from './menu-settings-data';

@Component({
  selector: 'thehubz-asset-view-actions',
  templateUrl: './asset-view-actions.component.html',
  styleUrls: ['./asset-view-actions.component.scss'],
})
export class AssetViewActionsComponent implements OnChanges {
  @Input() filteredList: AssetUIModel[] = [];
  @Input() currentTab = '';
  @Input() collectionPublished?: boolean = false;
  @Input() collectionOwner = false;
  @Input() appliedFilters!: AnyType;
  @Input() selectedViewType!: ViewType;
  @Input() selectedViewSection2: ViewType = 'sortByLastCreated';
  @Input() sortByNew!: boolean;
  @Input() assetCount!: number;
  @Input() gridSettingsKeySuffix = 'CollectionOverview';
  @Input() filterBubbles: AnyType;
  @Input() collectionInfo!: CollectionInfo;
  @Input() filterCollectionFormData!: AnyType;
  @Input() selectedFilterObject!: AnyType;
  @Input() formResetter!: Observable<{ _id: string; name: string; key: string } | undefined>;
  @Input() searchText = '';

  @Output() addOnEnter = new EventEmitter();
  @Output() downloadClick = new EventEmitter<AnyType>();
  @Output() publishCollection = new EventEmitter<AnyType>();
  @Output() unpublishCollection = new EventEmitter<AnyType>();
  @Output() shareCollection = new EventEmitter<AnyType>();
  @Output() addToDashboard = new EventEmitter<AnyType>();
  @Output() clearSearch = new EventEmitter<AnyType>();
  @Output() applyFilters = new EventEmitter<AnyType>();
  @Output() searchTextChanged = new EventEmitter<AnyType>();
  @Output() deleteCollection = new EventEmitter<AnyType>();
  @Output() resetForm = new EventEmitter<AnyType>();
  @Output() updateFormData = new EventEmitter<AnyType>();
  @Output() currentSize = new EventEmitter<number>();
  @Output() sortBy = new EventEmitter<AnyType>();
  @Output() restFormField = new EventEmitter<AnyType>();
  @Output() toggleMobileSearch = new EventEmitter<AnyType>();
  @Output() viewAssetTags = new EventEmitter();

  AnyAsset = anyAsset;
  searchPlaceholder = SearchAssetsFieldPlaceholder;
  bulkEditButtonText = $localize`Bulk edit`;
  fullCollectionDownload!: boolean;
  bulkEditType = 'collection';

  size = 4;
  itemSize = 310;

  assetGalleryMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_GALLERY_MENU_SETTINGS);
  assetTableMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_TABLE_MENU_SETTINGS);

  gridConfig: GridConfig = {
    showListView: false,
    showGridView: true,
    showGridViewSmall: true,
    showGridViewLarge: false,
    showGridViewSidebar: false,
    gridSize: 4,
  };

  tableData: AnyType;
  dialogEditState?: number;

  CustomClients = CustomClients;

  constructor(
    @Inject(ENVIRONMENT) protected readonly env: ClientEnvironment,
    protected assetViewTypeService: AssetViewTypeService,
    private confirmDialog: ConfirmDialogService,
    private collectionAssetCommonService: CollectionAssetCommonService,
    protected assetCommonService: AssetCommonService,
    private collectionEventsService: CollectionEventsService,
    private collectionSelectionService: CollectionSelectionService,
    protected screenSizeDetectorService: ScreenSizeDetectorService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filteredList']) {
      if (this.filteredList.length) {
        const availableAssets = this.filteredList
          .map((asset) => {
            if (!asset.assetExpiryDays || asset.assetExpiryDays > 0) {
              return 1;
            }
            return 0;
          })
          .filter((value) => value !== 0).length;

        this.fullCollectionDownload = this.filteredList.length === availableAssets;
      }
    }

    this.collectionEventsService.collectionTableDataSubject$.subscribe((data) => {
      if (data) this.tableData = data;
    });
  }

  changeAssetView(view: AnyType, toggle?: boolean) {
    if (view !== 'list') {
      this.gridConfig.showListView = false;
      this.gridConfig.showGridView = true;

      if (view === 'grid_4') {
        this.gridConfig.showGridViewSmall = true;
        this.gridConfig.showGridViewLarge = false;
        this.gridConfig.showGridViewSidebar = false;
        this.gridConfig.gridSize = 4;
        this.selectedViewType = 'grid_4';
        this.size = 4;
        this.collectionEventsService.splitCollectionAssets.next(this.size);
      }
      if (view === 'grid_8') {
        this.gridConfig.showGridViewSmall = false;
        this.gridConfig.showGridViewLarge = true;
        this.gridConfig.showGridViewSidebar = false;
        this.gridConfig.gridSize = 8;
        this.selectedViewType = 'grid_8';
        this.size = 8;
        this.collectionEventsService.splitCollectionAssets.next(this.size);
      }
      if (view === 'grid_3') {
        this.gridConfig.showGridViewSmall = true;
        this.gridConfig.showGridViewLarge = false;
        this.gridConfig.showGridViewSidebar = true;
        this.gridConfig.gridSize = 3;
        this.selectedViewType = 'grid_3';
        this.size = 3;
        this.collectionEventsService.splitCollectionAssets.next(this.size);
      }
      if (view === 'grid_6') {
        this.gridConfig.showGridViewSmall = false;
        this.gridConfig.showGridViewLarge = true;
        this.gridConfig.showGridViewSidebar = true;
        this.gridConfig.gridSize = 6;
        this.selectedViewType = 'grid_6';
        this.size = 6;
        this.collectionEventsService.splitCollectionAssets.next(this.size);
      }
      this.currentSize.emit(this.size);
    } else {
      this.gridConfig.showGridView = false;
      this.gridConfig.showGridViewSmall = false;
      this.gridConfig.showGridViewLarge = false;
      this.gridConfig.showListView = true;
      this.gridConfig.showGridViewSidebar = toggle || false;
      this.selectedViewType = 'list';
    }

    this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
  }

  onApplyFilters(event: any) {
    if (event) {
      this.applyFilters.emit(event);
    } else {
      this.applyFilters.emit({});
    }
  }

  toggleSidebar() {
    const gridConfig: GridConfig = this.assetViewTypeService.getGridConfig(this.gridSettingsKeySuffix);
    if (gridConfig.showGridViewSmall && !gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_3');
    } else if (gridConfig.showGridViewSmall && gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_4');
    } else if (gridConfig.showGridViewLarge && !gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_6');
    } else if (gridConfig.showGridViewLarge && gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_8');
    } else if (gridConfig.showListView && !gridConfig.showGridViewSidebar) {
      this.changeAssetView('list', true);
    } else if (gridConfig.showListView && gridConfig.showGridViewSidebar) {
      this.changeAssetView('list', false);
    }
  }

  selectAll(check: boolean) {
    if (check) {
      this.filteredList.forEach((asset) => {
        asset.checked = true;
        asset.isAddedToBasket = true;
      });
      this.collectionInfo.assets?.forEach((asset) => {
        this.collectionSelectionService.updateCollectionBasket({ asset, checked: true });
      });
      this.collectionSelectionService.updateSelectedItems(
        'collection',
        this.collectionInfo.assets?.map((asset) => ({ _id: asset._id ?? asset.toString() })) ?? [],
        check,
      );
    } else {
      this.collectionSelectionService.updateCollectionBasket({} as AnyType, true);
      this.filteredList.forEach((asset) => {
        asset.checked = false;
        asset.isAddedToBasket = false;
      });
      this.collectionSelectionService.unSelectAll('collection', check);
    }
    this.collectionEventsService.collectionAssetDataSubject$.next(this.filteredList);
  }

  removeFromCollection(event: AnyType) {
    const assetList: AnyType = [];
    if (event) {
      event.forEach((element: AssetUIModel) => {
        assetList.push({ assetID: element._id.toString() });
      });
    }
    this.confirmDialog
      .open({
        title: $localize`Remove asset`,
        message: $localize`Are you sure you want to remove selected assets from the collection?`,
      })
      .subscribe((confirm: boolean) => {
        if (confirm) {
          this.assetCommonService.collectionRemoveAsset$.next(assetList);
        }
      });
  }

  editAssets(event: { editType: string; assets: AssetUIModel[]; domainMatching?: boolean }) {
    if (event.assets.length > 0 && this.filteredList?.length) {
      event.assets = event.assets.map((asset: AssetUIModel) => {
        if (!asset.name) {
          const assetIndex = this.filteredList?.findIndex((assetObject: AssetUIModel) => assetObject._id == asset._id);
          if (assetIndex != -1) {
            return this.filteredList[assetIndex];
          }
        }
        return asset;
      });
    }
    this.collectionAssetCommonService.editAssets(event);
  }

  getSelectedViewType() {
    const gridConfig: GridConfig = this.assetViewTypeService.getGridConfig(this.gridSettingsKeySuffix);
    if (gridConfig.showGridViewSmall && !gridConfig.showGridViewSidebar) {
      return 'grid_4';
    } else if (gridConfig.showGridViewSmall && gridConfig.showGridViewSidebar) {
      return 'grid_3';
    } else if (gridConfig.showGridViewLarge && !gridConfig.showGridViewSidebar) {
      return 'grid_8';
    } else if (gridConfig.showGridViewLarge && gridConfig.showGridViewSidebar) {
      return 'grid_6';
    } else if (gridConfig.showListView && !gridConfig.showGridViewSidebar) {
      return 'list';
    } else if (gridConfig.showListView && gridConfig.showGridViewSidebar) {
      return 'list';
    }
    return 'grid_4';
  }
}
